import Typography from '@mui/material/Typography';

import dropoffIcon from '@/assets/create-order/icon_dropoff.svg';

const DropoffTitle = () => {
  return (
    <Typography variant="subtitle2" component="div" sx={{ display: 'flex', alignItems: 'center' }}>
      <img
        src={dropoffIcon}
        alt="Icon"
        style={{ width: '24px', height: '24px', marginRight: '8px' }}
      />
      <span>
        ¿A dónde <span className="text-primary">enviamos</span> tu{' '}
        <span className="text-primary">paquete</span>?
      </span>
    </Typography>
  );
};

export default DropoffTitle;
